import { api } from '@/modules/apiv2';

export default {
  state: {
    webChatURL: '',
  },

  getters: {
    webChatURL(state) {
      return state.webChatURL;
    },
  },

  mutations: {
    setWebChatUrl(state, webChatURL) {
      state.webChatURL = webChatURL;
    },
  },

  actions: {
    async populateWebChatURL({ commit, getters }) {
      if (!getters.currentUserIsAdmin) {
        // Current user is not an admin, so we cannot fetch the web chat URL
        return '';
      }
      const endpoint = getters.webBotEndpoint;
      let data;
      try {
        data = await api.get(endpoint);
      } catch (e) {
        console.error('Retrieved FAQ bot Failure');
        commit('setWebChatUrl', '');
        throw e;
      }

      commit('setWebChatUrl', data);
      return data;
    },
  },
};
